import { render, staticRenderFns } from "./manuscriptUpload.vue?vue&type=template&id=023db6b5&scoped=true&lang=html"
import script from "./manuscriptUpload.vue?vue&type=script&lang=js"
export * from "./manuscriptUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023db6b5",
  null
  
)

export default component.exports